import { DpOrderEntry } from '@app/core/types/view/dp-order-entry.interface';
import { ADDITIONAL_FIELDS } from '@app-modules/cart/shared/constants/additional-fields.constant';
import { cartInputValidators } from '@app-shared/cart/constants/cart-input-validators.constant';
import { CartAdditionalFieldValue } from '@app-shared/cart/types/cart-additional-field-value.type';
import { CartAdditionalField } from '@app-shared/cart/types/cart-additional-field.type';

export const cartAdditionalFieldsMapper = (payload: string[]): CartAdditionalField[] => {
  const correctLabelOrder = Object.values(ADDITIONAL_FIELDS);
  return correctLabelOrder.reduce((acc: CartAdditionalField[], label) => {
    const parts = label.split('_');
    const alteredLabel = parts[0].toLowerCase() + parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
    if (payload.includes(label)) {
      acc[correctLabelOrder.indexOf(label)] = additionalFieldMapper(label, alteredLabel);
    }

    return acc.filter(Boolean);
  }, []);
};

export const entriesValuesMapper = (
  fields: CartAdditionalField[],
  entries: DpOrderEntry[]
): CartAdditionalFieldValue[] => {
  const entriesValues: CartAdditionalFieldValue[] = [];
  entries.forEach((entry: DpOrderEntry) => {
    entriesValues[entry.entryNumber ?? 0] = entryValuesMapper(fields, entry);
  });
  return entriesValues;
};

const additionalFieldMapper = (code: string, label: string): CartAdditionalField => ({
  code,
  label,
  description: `cartDetails.${label}Title`,
  validators: cartInputValidators[label]
});

const entryValuesMapper = (fields: CartAdditionalField[], entry: DpOrderEntry): CartAdditionalFieldValue =>
  fields.reduce((acc: CartAdditionalFieldValue, { label }: CartAdditionalField): CartAdditionalFieldValue => {
    const key = label === 'entryOpenText' ? 'openText' : label;
    return { ...acc, [key]: entry[key as keyof DpOrderEntry] ? String(entry[key as keyof DpOrderEntry]) : null };
  }, {});
